<template>
  <nav :class="$style['toolbar-navigation']">
    <NuxtLink
      v-for="item in mainNavigation.filter(item => item.valid)"
      :key="item.id"
      :tabindex="isHidden ? -1 : 0"
      :no-prefetch="true"
      :aria-label="item.title"
      :to="{
        path: `/${$lang}/${item.slug}`
      }"
      :class="[
        $style['toolbar-navigation__item'],
        {
          [$style['toolbar-navigation__item--active']]: isActive(`/${$lang}/${item.slug}`)
        },
        {
          [$style['toolbar-navigation__item--dropdown']]: item.subItems.length
        },
        {
          [$style['toolbar-navigation__item--dropdown--hover']]:
            hover && item.id == id
        }
      ]"
      @click="$emit('click')"
      @mouseenter="handleHoverEnter(item.id)"
      @mouseleave="emit('on-leave')">
      <span>{{ item.title ?? item[0].title }}</span>
    </NuxtLink>
  </nav>
</template>
<script setup>
const { timedNavigation } = useTimedNavigation()
const route = useRoute()
const emit = defineEmits(['on-enter', 'on-leave', 'click'])
defineProps({
  hover: {
    default: null,
    type: [Number, Boolean]
  },
  isHidden: {
    type: Boolean,
    default: false
  }
})

const id = ref(0)

const mainNavigation = computed(() => {
  return timedNavigation({ filterByLocation: 'main' })
})

const isActive = slug => {
  return route.fullPath.startsWith(slug)
}

const handleHoverEnter = itemId => {
  id.value = itemId
  emit('on-enter', itemId)
}
</script>
<style lang="scss" module>
.toolbar-navigation {
  display: inline-flex;
  height: 100%;
  width: auto;

  &__item {
    align-items: center;
    justify-content: center;
    display: inline-flex;
    color: var(--grey-dark);
    cursor: pointer;
    height: 100%;
    line-height: var(--line-height);
    font-weight: var(--font-weight-bold);
    padding: 0 calc(var(--spacing) * 1.5);
    position: relative;
    text-decoration: none;
    white-space: nowrap;
    overflow: hidden;
    width: auto;
    transition: .3s;

    &:hover,
    &--active {
      color: var(--black);
    }

    &:focus-visible {
      box-shadow: var(--focus-visible);
    }

    :global(.transparent-toolbar):not(:hover) & {
      color: var(--white)
    }

    &--dropdown {
      transition: color var(--transition-time) var(--transition-easing);
      position: relative;

      &--hover {
        background-color: var(--grey-darkest);
        color: var(--white);
      }
    }

    @media (min-width: #{$breakpoint-desktop}) {
      padding: 0 calc(var(--spacing ) * 2);
    }
  }
}
</style>
